// Bulk select functionality for SEO fixes page
// This file is loaded once and handles all pages via event delegation

(function() {
  'use strict';
  
  function updateBulkSelect() {
    const checkboxes = document.querySelectorAll('.fix-checkbox');
    const checked = document.querySelectorAll('.fix-checkbox:checked');
    const count = checked.length;
    
    // Update count display
    document.querySelectorAll('#selected-count').forEach(el => {
      el.textContent = count;
    });
    
    // Enable/disable buttons
    const approveBtn = document.getElementById('bulk-approve-btn');
    const deleteBtn = document.getElementById('bulk-delete-btn');
    if (approveBtn) approveBtn.disabled = count === 0;
    if (deleteBtn) deleteBtn.disabled = count === 0;
    
    // Update hidden inputs for approve form
    const approveContainer = document.getElementById('bulk-approve-fix-ids');
    if (approveContainer) {
      approveContainer.innerHTML = '';
      checked.forEach(cb => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'fix_ids[]';
        input.value = cb.value;
        approveContainer.appendChild(input);
      });
    }
    
    // Update hidden inputs for delete form
    const deleteContainer = document.getElementById('bulk-delete-fix-ids');
    if (deleteContainer) {
      deleteContainer.innerHTML = '';
      checked.forEach(cb => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'fix_ids[]';
        input.value = cb.value;
        deleteContainer.appendChild(input);
      });
    }
    
    // Update select all checkbox state
    const selectAll = document.getElementById('select-all-fixes');
    if (selectAll) {
      const total = checkboxes.length;
      selectAll.checked = count === total && total > 0;
      selectAll.indeterminate = count > 0 && count < total;
    }
  }
  
  function handleChange(e) {
    if (e.target.id === 'select-all-fixes') {
      const checked = e.target.checked;
      const checkboxes = document.querySelectorAll('.fix-checkbox');
      checkboxes.forEach(cb => {
        cb.checked = checked;
      });
      updateBulkSelect();
    } else if (e.target.classList.contains('fix-checkbox')) {
      updateBulkSelect();
    }
  }
  
  function handleCheckboxEvent(e) {
    const target = e.target;
    // Use setTimeout to ensure browser has updated checkbox state
    setTimeout(function() {
      if (target.id === 'select-all-fixes') {
        const checked = target.checked;
        const checkboxes = document.querySelectorAll('.fix-checkbox');
        checkboxes.forEach(cb => {
          cb.checked = checked;
        });
        updateBulkSelect();
      } else if (target.classList.contains('fix-checkbox')) {
        updateBulkSelect();
      }
    }, 0);
  }
  
  function init() {
    updateBulkSelect();
  }
  
  function runInit() {
    // Check if we're on the SEO fixes page
    const controllerElement = document.querySelector('[data-controller*="bulk-select"]');
    if (controllerElement) {
      init();
    }
  }
  
  // Set up event delegation (only once)
  if (!window.bulkSelectFixesInitialized) {
    window.bulkSelectFixesInitialized = true;
    document.addEventListener('change', handleChange, true);
    document.addEventListener('input', handleCheckboxEvent, true);
    document.addEventListener('click', handleCheckboxEvent, true);
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
  
  // Re-initialize on Turbo navigation (always run, not just once)
  document.addEventListener('turbo:load', runInit);
  document.addEventListener('turbo:frame-load', runInit);
})();
